import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaContent from './VaContent.vue'

export const VaContent = withConfigTransport(_VaContent)
